import * as React from "react";

import {
  ProminentErrorMessageBox,
  ReCaptcha,
  SingleLineTextInput,
} from "../../Common";

import { useGiftcardBalance, useReactGiftCardInitialState } from "../providers";

export const AccessForm: React.FunctionComponent = () => {
  const { initialState } = useReactGiftCardInitialState();
  const { giftcard_balance_recaptcha } = initialState || {};
  const {
    accessForm,
    onFormFieldFocus,
    onFormInputChange,
    onFormInputBlur,
    onCheckYourBalance,
  } = useGiftcardBalance();

  const onFormSubmit: React.MouseEventHandler<HTMLButtonElement> = async (
    event
  ) => {
    event.preventDefault();
    const isRecaptchaV3 = initialState.giftcard_balance_recaptcha?.recaptchaEnabled as unknown as string === 'reCAPTCHA v3 Invisible';

    if (isRecaptchaV3 && (window as any).grecaptcha) {
      try {
        const captchaWrapperId = initialState.giftcard_balance_recaptcha?.recaptchaId + "-react-wrapper";
        const recaptchaElement = (document.querySelector("#" + captchaWrapperId)?.querySelector(".g-recaptcha-response")) as HTMLTextAreaElement;
        const token = await (window as any).grecaptcha.execute(
          (window as any).recaptchaSiteKey,
          {action: "validate_captcha"}
        );

        if (recaptchaElement && token) {
          recaptchaElement.value = token;
        }
      } catch (e) {
        console.log(e);
      }
    }

    onCheckYourBalance();
  };

  return (
    <form className="access-form">
      <SingleLineTextInput
        name="giftcardNumber"
        form={accessForm}
        onFocus={onFormFieldFocus}
        onChange={onFormInputChange}
        onBlur={onFormInputBlur}
        displayName="Gift Card Number"
        notice="The 19-digit number on your PDF or on the back of your card."
      />

      <SingleLineTextInput
        type="password"
        autoComplete="bbnt-giftcard-pin"
        name="giftcardPin"
        form={accessForm}
        onFocus={onFormFieldFocus}
        onChange={onFormInputChange}
        onBlur={onFormInputBlur}
        displayName="PIN"
        notice="The 4-digit security code on your PDF or on the back of your card."
      />

      <ReCaptcha
        form={accessForm}
        name="recaptcha"
        onChange={onFormInputChange}
        recaptchaConfiguration={giftcard_balance_recaptcha}
      />

      <ProminentErrorMessageBox />

      <button className="check-your-balance" onClick={onFormSubmit}>
        Check Your Balance
      </button>
    </form>
  );
};
